import actionTypes from '../../actions/actionTypes'
import { Map, fromJS, List } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { deleteItem } from './helpers'

const INIT_STATE = fromJS(PROGRAM_DEFAULT.itemCollections)

// const _itemCollectionsFactory = (dateStart, dateEnd) => {
//     return Map({
//         dateStart: dateStart,
//         dateEnd: dateEnd,
//         edited: false,
//         items: List()
//     })
// }

// const addItem = (state, action) => state.setIn(['items', action.payload.pk], _itemCollectionsFactory(action.payload.dateStart, action.payload.dateEnd))
const setItemItems = (state, action) => state.setIn(['items', action.payload.pk.toString(), 'items'], action.payload.items)
const setItemEdited = (state, action, value) => state.setIn(['items', action.payload.pk.toString(), 'edited'], value)


const itemCollectionsReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type) {
        // case actionTypes.ITEMCOLLECTIONS_ADD_ITEM:
        //     return addItem(state, action)
        case actionTypes.ITEMCOLLECTIONS_DELETE_ITEM:
            return deleteItem(state, action)
        case actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_ITEMS:
            return setItemItems(state, action)
        case actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_TRUE:
            return setItemEdited(state, action, true)
        case actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_FALSE:
            return setItemEdited(state, action, false)
        default:
            return state
    }
}

export default itemCollectionsReducer